// extracted by mini-css-extract-plugin
export default {"container":"not-found__container___f8HuV","notFound":"not-found__notFound___pAayw"};